export default [
  // 常见问题faq
  {
    path: '/qa',
    name: 'QA',
    component: () => import('@/upgrade-page/views/static/qa'),
    meta: {
      hideNav: true,
      needMedia: true
    }
  },
  // 如何獲取更多訂單faq
  {
    path: '/order-score',
    name: 'OrderScore',
    component: () => import('@/upgrade-page/views/static/order-score'),
    meta: {
      hideNav: true
    }
  },
  // 質量分faq
  {
    path: '/player-score',
    name: 'PlayerScore',
    component: () => import('@/upgrade-page/views/static/score'),
    meta: {
      hideNav: true
    }
  },
  /** 隱私協議、用戶協議 */
  {
    path: '/privacy',
    name: 'Privacy',
    component: () => import('@/upgrade-page/views/static/privacy'),
    meta: {
      hideNav: true,
      needMedia: true
    }
  },
  /** 隱私協議 */
  {
    path: '/newprivacy',
    name: 'Newprivacy',
    component: () => import('@/upgrade-page/views/static/newprivacy'),
    meta: {
      hideNav: true
    }
  },
  /** 用戶協議 */
  {
    path: '/compact',
    name: 'Compact',
    component: () => import('@/upgrade-page/views/static/compact'),
    meta: {
      hideNav: true
    }
  },
  /** 行為守則 */
  {
    path: '/rules',
    name: 'Rules',
    component: () => import('@/upgrade-page/views/static/rules'),
    meta: {
      // pageWidth: '100%',
      hideNav: true,
      needMedia: true
    }
  },
  /** 自助提領指南 */
  {
    path: '/withdraw-guide',
    name: 'withdrawGuide',
    component: () => import('@/upgrade-page/views/withdraw/withdrawGuide'),
    meta: {
      pageWidth: 980
    }
  },
  /**
   * 爽爽賺佣金
   */
  {
    path: '/player-referral',
    name: 'referral',
    component: () => import('@/upgrade-page/views/referral/index'),
    meta: {
      pageWidth: '100%',
      hideNav: true,
      needMedia: true
    }
  },
  // app 啟動入口
  {
    path: '/line-on',
    name: 'LineOn',
    component: () => import('@/upgrade-page/views/line-on/index'),
    meta: {
      hideNav: true
    }
  },
  // app 申請入駐入口
  {
    path: '/apply',
    name: 'ApplySettlement',
    component: () => import('@/upgrade-page/views/apply/index')
  },
  // 如何獲取更多訂單faq
  {
    path: '/emailus',
    name: 'Emailus',
    component: () => import('@/upgrade-page/views/static/email-us'),
    meta: {
      hideNav: true
    }
  },
  // 动态-最近
  {
    path: '/recent-dynamic',
    name: 'RecentDynamic',
    component: () => import('@/upgrade-page/views/static/recent-dynamic'),
    meta: {
      hideNav: true
    }
  },
  // 安裝包下載
  {
    path: '/download-app',
    name: 'DownloadApp',
    component: () => import('@/upgrade-page/views/static/download-app'),
    meta: {
      hideNav: true
    }
  },
  // seo版块内容
  {
    path: '/blog',
    name: 'Blog',
    component: () => import('@/upgrade-page/views/static/blog/index.vue'),
    meta: {
      needMedia: true
    }
  },
  // seo版块内容
  {
    path: '/blog/:title',
    name: 'BlogDetail',
    component: () => import('@/upgrade-page/views/static/blog/detail.vue'),
    meta: {
      needMedia: true
    }
  },
  // 安裝包下載
  {
    path: '/app',
    name: 'PcDownloadApp',
    component: () => import('@/upgrade-page/views/static/pc-download-app'),
    meta: {
      hideNav: true,
      needMedia: true
    }
  },
  /** 聯繫我們 */
  {
    path: '/contact-us',
    name: 'ContactUs',
    component: () => import('@/upgrade-page/views/static/contact-us'),
    meta: {
      // pageWidth: '100%',
      hideNav: true,
      needMedia: true
    }
  }
];
